import React from "react";

const ReportTypeSelection = ({ selectedType, onSelect, onNext }) => {
  const reportTypes = [
    {
      id: "roadmap",
      name: "Roadmap",
      icon: "📅",
      description:
        "Visualize entity timelines with lifecycle status, clustering, and successor relationships. Perfect for planning and tracking application roadmaps.",
      features: [
        "Timeline visualization (Year/Quarter/Month zoom)",
        "Entity clustering by type or attribute",
        "Successor/predecessor relationships",
        "Lifecycle status indicators",
      ],
    },
    {
      id: "data-quality",
      name: "Data Quality",
      icon: "📊",
      description:
        "Create tabular reports with custom attributes, advanced filtering, and clustering. Ideal for data analysis and quality assessment.",
      features: [
        "Custom column selection",
        "Advanced filtering (equals, contains, >, <, etc.)",
        "Entity clustering/grouping",
        "Aggregations (sum, avg, count, etc.)",
      ],
    },
    {
      id: "relationship",
      name: "Relationship Analysis",
      icon: "🔗",
      description:
        "Analyze dependencies, impacts, and connections between entities. Essential for change management and understanding system interdependencies.",
      features: [
        "Impact analysis (what will be affected)",
        "Dependency mapping (upstream/downstream)",
        "Multi-hop relationship traversal",
        "Gap and coverage analysis",
      ],
    },
  ];

  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-2">
        Select Report Type
      </h2>
      <p className="text-gray-400 mb-6">
        Choose the type of report you want to create
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {reportTypes.map((type) => (
          <div
            key={type.id}
            onClick={() => onSelect(type.id)}
            className={`p-6 rounded-lg border-2 cursor-pointer transition-all ${
              selectedType === type.id
                ? "border-blue-500 bg-blue-900/20"
                : "border-gray-700 bg-gray-800 hover:border-gray-600"
            }`}
          >
            <div className="flex items-start gap-4">
              <div className="text-4xl">{type.icon}</div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-white mb-2">
                  {type.name}
                </h3>
                <p className="text-sm text-gray-400 mb-3">{type.description}</p>
                <ul className="text-xs text-gray-500 space-y-1">
                  {type.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-blue-400 mt-1">•</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              {selectedType === type.id && (
                <div className="text-blue-500">
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-end">
        <button
          onClick={onNext}
          disabled={!selectedType}
          className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
            selectedType
              ? "bg-blue-600 hover:bg-blue-700 text-white"
              : "bg-gray-700 text-gray-500 cursor-not-allowed"
          }`}
        >
          Next: Basic Information
        </button>
      </div>
    </div>
  );
};

export default ReportTypeSelection;
